// extracted by mini-css-extract-plugin
export default {"Container":"Federal_Container__gsJAj","section-1":"Federal_section-1__ScP-2","content":"Federal_content__L1UNr","section-2":"Federal_section-2__xI3Uk"};